import { Typography, Box, Stack } from "@mui/material";
import MzButton from "@markaaz/ui/MzButton";
import MzAlert from "@markaaz/ui/MzAlert";
import UserGrid from "./UserGrid";
import UserForm from "./UserForm";

const sx = {
  header: {
    display: "flex",
    alignItems: "center"
  },

  title: {
    h4: {
      color: "darkBlue.c100"
    },
    flexGrow: 1
  },

  btnInvite: {
    marginTop: "40px"
  },

  usersHeader: {
    marginTop: "50px",
    marginBottom: "30px"
  },

  gridTitle: {
    color: "darkBlue.c100"
  },

  gridDescWrapper: {
    maxWidth: "860px",
    display: "flex"
  },

  gridDesc: {
    color: "darkBlue.c100"
  }
};

export default function UserManagementMain({
  loading,
  isPartnerChanged,
  users,
  roles,
  companyName,
  selectedPartner,
  selectedUser,
  formOpen,
  isAdmin,
  showNotification,
  openInviteSentForm,
  onInviteUser,
  onEditUser,
  onFormClose,
  onSubmit,
  onDelete,
  onResend,
  onAlertClose,
  onInviteSentFormClose
}) {
  return (
    <Box height="100%" display="flex" flexDirection="column">
      <Box sx={sx.header}>
        <Box sx={sx.title}>
          <Typography variant="h4">User Management</Typography>
        </Box>
      </Box>
      <Box sx={sx.usersHeader}>
        <Typography sx={sx.gridTitle} variant="h6">
          Users
        </Typography>
        <Box sx={sx.gridDescWrapper}>
          <Typography sx={sx.gridDesc} variant="body2">
            New users are invited via a 2FA authentication email. The verification code is valid for 24 hours, after
            which time, the verification code will expire and the Admin will have to click Resend Verification.
          </Typography>
        </Box>
      </Box>
      <Box flexGrow={1}>
        <UserGrid
          loading={loading}
          data={users}
          openInviteSentForm={openInviteSentForm}
          onEdit={onEditUser}
          onDelete={onDelete}
          onResend={onResend}
          onInviteSentFormClose={onInviteSentFormClose}
        />
      </Box>
      <Stack direction="row" gap={10} alignItems="center">
        <MzButton sx={sx.btnInvite} variant="contained" onClick={onInviteUser} disabled={!isPartnerChanged}>
          Invite New User
        </MzButton>
        {showNotification.message && (
          <MzAlert
            sx={{ alignItems: "center", marginTop: "40px" }}
            severity={showNotification.type === "success" ? "success" : "error"}
            onClose={onAlertClose}
          >
            {showNotification.message}
          </MzAlert>
        )}
      </Stack>

      <UserForm
        open={formOpen}
        companyName={companyName}
        selectedUser={selectedUser}
        selectedPartner={selectedPartner}
        roles={roles}
        isAdmin={isAdmin}
        onClose={onFormClose}
        onSubmit={onSubmit}
      />
    </Box>
  );
}
